import { render, staticRenderFns } from "./step1.vue?vue&type=template&id=5c37f23d&scoped=true"
import script from "./step1.vue?vue&type=script&lang=js"
export * from "./step1.vue?vue&type=script&lang=js"
import style0 from "./step1.vue?vue&type=style&index=0&id=5c37f23d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c37f23d",
  null
  
)

export default component.exports